import React, { useState, useEffect } from 'react'
import DC_img from '../../../Images/DC-Banner.png'
import Why_DC from '../../../Images/why-bmc-2.png'
import Modal from 'react-bootstrap/Modal';
import Navbar from '../../../ReusableBlocks/Navbar'
import { Link, useNavigate } from "react-router-dom";
import Girl_Img from '../../../Images/Girl-image-2.png'

import Boy_Img_2 from '../../../Images/Boy_img-3.png'
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';


import 'react-toastify/dist/ReactToastify.css';
import LoadingScreen from '../../../ReusableBlocks/LoadingScreen';
import CryptoJS from 'crypto-js';
import { useDispatch, useSelector } from 'react-redux';
import { fetchNarratives } from '../../../Redux/Dashboard/External/Home/HomePageContentAction';
import { fetchNewContent } from '../../../Redux/Dashboard/External/Whatsnew/WhatNewAction';
import Swal from 'sweetalert2';
import * as PATH from '../../../CentralisedLink'

import { useSnackbar } from 'notistack';



// Sales Import
import Slider from "react-slick";
import SalesNavbar from '../../../ReusableBlocks/SalesNavbarForHomePage'

import { fetchSales } from '../../../Redux/Dashboard/External/SalesDemo/Actions/SalesPersonaHomAction';
import { fetchExistingDemoSessionAct, clearExistingDemoSession } from '../../../Redux/Dashboard/External/SalesDemo/Actions/FetchExistingDemoSessionAction';
import { createCustomerDemoSessionAct, createInternalDemoSessionAct, clearcreateDemoSession } from '../../../Redux/Dashboard/External/SalesDemo/Actions/CreateDemoSessionAction';

import { Button, Form, Col, Row } from 'react-bootstrap';
import { jwtDecode } from 'jwt-decode';
import { normalizeMediaUrl } from '../../../Utils/mediaUrls';
import { useFeatureFlags } from '../../../FeatureFlags/FeatureFlagsContext';
import { FEATURE_FLAGS } from '../../../FeatureFlags/featureFlagConstants';

const WHATS_NEW_OPEN_EVENT = 'techCentralWhatsNewOpened';
const WHATS_NEW_CLOSED_EVENT = 'techCentralWhatsNewClosed';
const WHATS_NEW_POPUP_OPENED_EVENT = 'whatsNewPopupOpened';
const WHATS_NEW_POPUP_CLOSED_EVENT = 'whatsNewPopupClosed';
const WHATS_NEW_SHOWN_THIS_SESSION_KEY = 'whatsNewShownThisSession';

const getFirstStringValue = (values) => {
  return values.find((value) => typeof value === 'string' && value.trim()) || '';
};

const getUserEmail = (authState) => {
  const currentUser = authState?.currentUser || {};
  const authUser = authState?.user || {};
  let decodedToken = authState?.decodedToken || {};

  if (!decodedToken.email && authState?.accessToken) {
    try {
      decodedToken = jwtDecode(authState.accessToken) || {};
    } catch (error) {
      decodedToken = authState?.decodedToken || {};
    }
  }

  return getFirstStringValue([
    currentUser.email,
    currentUser.username,
    currentUser.emailAddress,
    currentUser.userEmail,
    currentUser.preferred_username,
    currentUser.upn,
    currentUser.sub,
    authUser.email,
    authUser.username,
    authUser.emailAddress,
    decodedToken.email,
    decodedToken.username,
    decodedToken.emailAddress,
    decodedToken.preferred_username,
    decodedToken.upn,
    decodedToken.sub,
  ]);
};







const Homepage = (props) => {

  const navigate = useNavigate();
  const secretKey = 'narrative';
  const { enqueueSnackbar } = useSnackbar();

  const isDisclaimerAccepted = localStorage.getItem('IsDisclaimerAccepted');



  const encryptId = (id) => {
    const ciphertext = CryptoJS.AES.encrypt(id, secretKey).toString();
    return encodeURIComponent(ciphertext);
  };


  const dispatch = useDispatch();
  const { isFeatureEnabled } = useFeatureFlags();
  const enableSalesDemo = isFeatureEnabled(FEATURE_FLAGS.EnableSalesDemo);
  const enableSearch = isFeatureEnabled(FEATURE_FLAGS.EnableSearch);
  const enableDemoIngestions = isFeatureEnabled(FEATURE_FLAGS.EnableDemoIngestions);
  const enableWhatsNew = isFeatureEnabled(FEATURE_FLAGS.EnableWhatsNew);
  const enableEnablement = isFeatureEnabled(FEATURE_FLAGS.EnableEnablement);
  const { homePageContent } = useSelector(state => state);

  useEffect(() => {
    return () => {
      Swal.close(); // Close any active Swal instance on unmount or redirection
    };
  }, []);

  const isLoading = useSelector(state => state.homePageContent?.loading);
  const errorMessage = useSelector(state => state.homePageContent?.error);
  const { newContent } = useSelector(state => state.whatNewReducer);
  console.log(newContent)
  const newDemoNarratives = homePageContent?.narratives?.['new-narratives'];
  const regionalTopNarratives = homePageContent?.narratives?.['regional-top-narratives'];
  const frequentlyNarratives = homePageContent?.narratives?.['user-frequent-narratives'];

  const hotNarratives = homePageContent?.narratives?.['hot-narratives'] || [];

  // State Variable
  const [showWhatsNew, setShowWhatsNew] = useState(false);
  const [showDCModal] = useState(false);

  const [searchQuery, setSearchQuery] = useState('');
  const [newNarratives, setNewNarratives] = useState([]);
  const [frequentNarratives, setFrequentNarratives] = useState([]);
  const [trendingNarratives, setTrendingNarratives] = useState([]);
  const [popupShown, setPopupShown] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPlaybookModalOpen, setIsPlaybookModalOpen] = useState(false);
  const [selectedPlaybooks, setSelectedPlaybooks] = useState([]);
  const [selectedPlaybook, setSelectedPlaybook] = useState(null);
  const authState = useSelector(state => state.auth);
  const currentUser = authState.currentUser;

  const userType = currentUser?.typeOfUser;
  const userEmail = getUserEmail(authState);
  const isBmcUser = userEmail?.toLowerCase().trim().endsWith("@bmc.com");
  const isExternalSE = String(userType || '').trim().toLowerCase() === 'external se';
  const shouldBlockWhatsNewForMigration =
    authState?.isAuthenticated &&
    isBmcUser &&
    !isExternalSE;

  // ---------------------------------------------//

  // Tempory User Role



  const settings2 = {
    dots: false, // Show dots navigation
    infinite: true, // Enable infinite looping
    speed: 500, // Transition speed in ms
    slidesToShow: 3, // Number of items visible at a time
    slidesToScroll: 3, // Number of items to scroll at a time
    autoplay: false, // Auto-slide items
    autoplaySpeed: 2000, // Auto-slide interval in ms
    centerMode: false, // Enable centered mode
    centerPadding: "2px", // Space between cards
  };

  // --------------------------------------------//


  const handleShowWhatsNew = () => {
    if (shouldBlockWhatsNewForMigration) {
      setShowWhatsNew(false);
      return;
    }

    setShowWhatsNew(true);
    sessionStorage.setItem(WHATS_NEW_SHOWN_THIS_SESSION_KEY, 'true');
    window.dispatchEvent(new Event(WHATS_NEW_OPEN_EVENT));
    window.dispatchEvent(new Event(WHATS_NEW_POPUP_OPENED_EVENT));
  };


  const handleCloseWhatsNew = () => {
    setShowWhatsNew(false);
    setPopupShown(false);
    localStorage.setItem('WhatNewPopup', false)
    window.dispatchEvent(new Event(WHATS_NEW_CLOSED_EVENT));
    window.dispatchEvent(new Event(WHATS_NEW_POPUP_CLOSED_EVENT));
  };




  useEffect(() => {

    if (currentUser?.typeOfUser !== 'Sales') {
      dispatch(fetchNarratives());
    }
    if (enableWhatsNew) {
      dispatch(fetchNewContent());
    }



  }, [dispatch, currentUser?.typeOfUser, enableWhatsNew]);


  useEffect(() => {
    if (errorMessage && errorMessage !== 'You have not completed mandatory Tech Central Training, please complete it.') {
      Swal.fire({
        title: 'Error',
        text: errorMessage,
        icon: 'error',
        confirmButtonText: 'Retry',
        showCancelButton: true,
        customClass: {
          title: 'my-custom-title-of-pop-login',
          confirmButton: 'my-custom-button-of-pop',
        },
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload();
        }
      });
    }



  }, [errorMessage]);


  useEffect(() => {
    console.log("errorMessage", errorMessage);
    const WhatsNew = localStorage.getItem('WhatNewPopup');
    console.log(WhatsNew);

    if (shouldBlockWhatsNewForMigration) {
      setShowWhatsNew(false);
      window.dispatchEvent(new Event(WHATS_NEW_CLOSED_EVENT));
      window.dispatchEvent(new Event(WHATS_NEW_POPUP_CLOSED_EVENT));
      return undefined;
    }

    const timer = setTimeout(() => {
      if (errorMessage !== null && errorMessage === 'You have not completed mandatory Tech Central Training, please complete it.') {
        setShowWhatsNew(false);
        window.dispatchEvent(new Event(WHATS_NEW_CLOSED_EVENT));
        window.dispatchEvent(new Event(WHATS_NEW_POPUP_CLOSED_EVENT));

      } else if (errorMessage === null && (errorMessage !== 'You have not completed mandatory Tech Central Training, please complete it.' || errorMessage == null) && WhatsNew === 'true') {
        handleShowWhatsNew();
        setPopupShown(true); // Set the popup as shown
      } else if (errorMessage === null && (errorMessage !== 'You have not completed mandatory Tech Central Training, please complete it.' || errorMessage == null) && WhatsNew !== 'true') {
        window.dispatchEvent(new Event(WHATS_NEW_CLOSED_EVENT));
        window.dispatchEvent(new Event(WHATS_NEW_POPUP_CLOSED_EVENT));
      }
    }, 3000); // Adjust the delay as needed

    return () => clearTimeout(timer); // Cleanup the timeout if the effect runs again
  }, [errorMessage, popupShown, shouldBlockWhatsNewForMigration]);


  useEffect(() => {
    // Directly set the state variables with the provided data
    setNewNarratives(homePageContent.narratives?.['new-narratives'] || []);
    setFrequentNarratives(homePageContent.narratives?.['user-frequent-narratives'] || []);
    setTrendingNarratives(homePageContent.narratives?.['regional-top-narratives'] || [])

  }, [newDemoNarratives, regionalTopNarratives, frequentlyNarratives]);











  const handlePlaybookClick = (playbook) => {
    if (Array.isArray(playbook) && playbook.length > 1) {
      setSelectedPlaybooks(playbook);
      setIsModalOpen(true);
    } else if (Array.isArray(playbook) && playbook.length === 1) {
      setSelectedPlaybook(playbook[0]);
      setIsPlaybookModalOpen(true);
    } else if (playbook) {
      setSelectedPlaybook(playbook);
      setIsPlaybookModalOpen(true);
    }
  };

  const handlePlaybookSelection = (playbook) => {
    setSelectedPlaybook(playbook);
    setIsModalOpen(false);
    setIsPlaybookModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedPlaybook(null);
    setSelectedPlaybooks([]);
  };

  const closePlaybookModal = () => {
    setIsPlaybookModalOpen(false);
    setSelectedPlaybook(null);
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text)
      .then(() => {
        enqueueSnackbar('Password copied to clipboard!', { variant: 'success' });
      })
      .catch(() => {
        enqueueSnackbar('Failed to copy Password.', { variant: 'error' });
      });
  };

  const formatDate = (dateString) => {
    const options = { day: 'numeric', month: 'short', year: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };


  const handleSearchInputChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSearchSubmit = (e) => {

    if (!searchQuery.trim()) {
      enqueueSnackbar('Please enter a search term.', { variant: 'error' });

      return;
    }

    navigate(`${PATH.SEARCH_PATH}?query=${encodeURIComponent(searchQuery)}`);
  };


  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSearchSubmit(e); // Pass the event object here
    }
  };







  const renderHeroContent = () => {
    if (currentUser?.typeOfUser === 'External SE') {
      return (
        <>
          <h1 class="v2-hero-title">
            <div class="v2-hero-top-text">Welcome to</div>
            <span class="v3-her0-title-span">Partner </span>
            <span class="v3-her0-title-span-two">Tech Central</span>
          </h1>
        </>

      );
    } else {
      return (
        <>
          <h1 class='v2-hero-title'>Welcome to <span className='v2-her0-title-span-two'>Tech Central</span></h1>
        </>
      );
    }
  }




  const renderHeroImage = () => {
    if (currentUser?.typeOfUser === 'External SE') {
      return (
        <img src={Boy_Img_2} className='girl-img' alt="" />
      );
    } else {
      return (
        <img src={Girl_Img} className='girl-img' alt="" />
      );
    }
  }




  const settings = {
    dots: true,
    infinite: false, // Set to false to prevent looping
    speed: 500,
    slidesToShow: 4, // Always show 1 slide
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1, // Ensure it adapts for smaller screens
          slidesToScroll: 1,
        },
      },
    ],
  };


  const salesPersonaResult = useSelector(state => state.SalesPersonaHomepage?.salesData);
  console.log(salesPersonaResult)

  const [exitingDemoPersona, setExitingDemoPersona] = useState(null);
  const [selectedPersonaTitle, setSelectedPersonaTitle] = useState(null);
  const [selectedPersonaId, setSelectedPersonaId] = useState(null);

  const [customerDetFormSess, setCustomerDetFormSess] = useState(false);
  const pendingDemo = salesPersonaResult['pending-demo'];

  // State for selected industry and custom industry input
  const [selectedIndustry, setSelectedIndustry] = useState('');
  const [customIndustry, setCustomIndustry] = useState('');
  const [suggestions, setSuggestions] = useState([]); // To store suggestions for custom industry input

  const [showSalesFormModel, setShowSalesFormModel] = useState(false);
  const [formType, setFormType] = useState(null);

  // Fields for customer form
  const [customerName, setCustomerName] = useState('');
  const [customerOrg, setCustomerOrg] = useState('');
  const [sfdcId, setSfdcId] = useState('');
  const [customerRole, setCustomerRole] = useState('');
  const [areaOfInterest, setAreaOfInterest] = useState([]);

  // Fields for internal form
  const [internalOption, setInternalOption] = useState(null); // either 'Meeting Prep' or 'Demo Practice'

  // Available options for Area of Interest
  const interests = ['AI Ops', 'HRSM', 'ITSM', 'Sec Ops', 'Dev Ops', 'Low Code', 'ESM'];

  // Sample industry suggestions
  const allIndustries = ['Automotive', 'Telco', 'Banking', 'Retail', 'Healthcare', 'Manufacturing'];


  // useEffect
  useEffect(() => {
    // Clear ExistingDemoSession when the component is mounted
    dispatch(clearExistingDemoSession());
    dispatch(clearcreateDemoSession());
  }, [dispatch]);


  //  Fetching Sales Personas
  useEffect(() => {
    if (!enableSalesDemo) {
      return;
    }

    dispatch(fetchSales());
  }, [dispatch, enableSalesDemo]);


  // Functions
  const handleShowSalesFormModel = async (personaId, title) => {
    setSelectedPersonaId(personaId);
    // setShowSalesFormModel(true);
    setSelectedPersonaTitle(title);





    const internalParams = {
      demoPurpose: 'Demo Practice',
    };


    console.log(internalParams)

    try {
      await dispatch(createInternalDemoSessionAct(personaId, internalParams));
      navigate(`${PATH.SALES_DASHBOARD_PATH}${encodeURIComponent(title)}`);
    } catch (error) {
      console.error('Error creating internal session:', error);
      alert('Failed to create an internal session.');
    }



  };

  const handleCloseSalesFormModel = () => {
    setShowSalesFormModel(false);
    window.location.reload();
  };

  const handleCustomIndustryChange = (e) => {
    const input = e.target.value;
    setCustomIndustry(input);

    // Show suggestions based on the input
    if (input.length > 0) {
      const filteredSuggestions = allIndustries.filter((industry) =>
        industry.toLowerCase().includes(input.toLowerCase())
      );
      setSuggestions(filteredSuggestions);
    } else {
      setSuggestions([]);
    }
  };

  const handleSuggestionClick = (suggestion) => {
    setCustomIndustry(suggestion); // Set the clicked suggestion as the input value
    setSuggestions([]); // Hide the suggestion list
  };

  // Handle area of interest selection
  const handleInterestSelection = (interest) => {
    setAreaOfInterest((prev) =>
      prev.includes(interest) ? prev.filter((i) => i !== interest) : [...prev, interest]
    );
  };


  const handleSubmit = async (e) => {
    e.preventDefault();



    if (formType === 'Customer') {
      if (!customerName || !customerOrg || !sfdcId || !customerRole || areaOfInterest.length === 0) {
        alert('Please fill in all required fields for Customer.');
        return;
      }

      const customerParams = {
        customerName,
        sfdc: sfdcId,
        customerOrg,
        customerRole,
        areasOfInterest: areaOfInterest,
        customerIndustry: {
          category: selectedIndustry,
          name: selectedIndustry === 'Others' ? customIndustry : '',
        },
      };

      try {
        await dispatch(createCustomerDemoSessionAct(selectedPersonaId, customerParams));
        navigate(`${PATH.SALES_DASHBOARD_PATH}${selectedPersonaTitle}`);
      } catch (error) {
        console.error('Error creating customer session:', error);
        alert('Failed to create a customer session.');
      }
    } else if (formType === 'Internal') {
      if (!internalOption) {
        alert('Please select an option for Internal.');
        return;
      }

      const internalParams = {
        demoPurpose: internalOption,
      };


      console.log(internalParams)

      try {
        await dispatch(createInternalDemoSessionAct(selectedPersonaId, internalParams));
        navigate(`${PATH.SALES_DASHBOARD_PATH}${selectedPersonaTitle}`);
      } catch (error) {
        console.error('Error creating internal session:', error);
        alert('Failed to create an internal session.');
      }
    } else {
      alert('Please select a form type.');
    }
  };


  const continueWithThisSession = async (title) => {

    console.log(`Continue with session for persona: ${title}`);

    // Find the persona object by matching the title
    setExitingDemoPersona(title);
    const personaDetails = salesPersonaResult['persona-details'];
    const matchedPersona = personaDetails.find(persona => persona.title === title);

    if (matchedPersona) {
      const personaId = matchedPersona._id;
      console.log(`Found Persona ID: ${personaId}`);
      // Continue with session logic using personaId
      // For example, navigate or fetch additional details
      // Example: navigateToSession(personaId);

      // dispatch(fetchExistingDemoSessionAct(personaId));

      // Dispatch the action and navigate after it resolves
      try {
        const sessionData = await dispatch(fetchExistingDemoSessionAct(personaId));
        console.log(exitingDemoPersona)
        if (sessionData.type === 'ExistingSession') {
          console.log(exitingDemoPersona)
          navigate(`${PATH.SALES_DASHBOARD_PATH}${title}`);
        }
      } catch (error) {
        console.error(`Failed to fetch session: ${error.message}`);
      }


    } else {
      console.log(`No matching persona found for title: ${title}`);
    }
  }



  // ---------------------------------------------//





  return (

    <>
      {isLoading && <LoadingScreen text="Welcome to Tech Central" />}


      {/* Sales Demos */}
      {currentUser?.typeOfUser === 'Sales' && enableSalesDemo ? (
        <>
          <div className="landing-page">

            {/* Navbar */}
            <SalesNavbar activeTabSales={"HOME"} />

            {/* Background SVG */}
            <div className="svg-background"></div>

            <div className='main-z'>

              <div className="main-content-area container">
                <h1 className="sal-h1"><span>W</span>ho are you <span>meeting today?</span></h1>
                <p className="paragraph-sales">Select the persona for your demo today and begin your demo journey with Tech Central.
                  <Link
                    to={`${PATH.SALES_WALKTHROUGH_PATH}?from=menu`}>
                    <span className="sales-question">How Sales Demos Work?</span>
                  </Link>
                </p>
              </div>


              {/* Slick Carousel */}
              <div className="carousel-section container">
                {salesPersonaResult['persona-details'] && salesPersonaResult['persona-details'].length > 0 ? (
                  <Slider {...settings}>
                    {salesPersonaResult['persona-details'].map((item) => (
                      <div
                        className="carousel-slide-sales"
                        key={item._id}
                        onClick={() => handleShowSalesFormModel(item._id, item.title)}

                      >
                        <div className="carousel-card-sales">
                          <img
                            src={normalizeMediaUrl(item.thumbnail, 'image')}
                            className="carousel-image-sales"
                            alt={item.title}
                          />
                          <div className="carousel-overlay-sales">
                            <h5 className="carousel-title-sales">{item.title}</h5>
                          </div>
                        </div>
                      </div>
                    ))}
                  </Slider>
                ) : (
                  <div className="carousel-fallback">
                    <p>No sales data available at the moment.</p>
                    <div className="carousel-placeholder">
                      <div className="carousel-card-sales">
                        <img
                          src="https://via.placeholder.com/300x200?text=No+Data"
                          className="carousel-image-sales"
                          alt="No Data"
                        />
                        <div className="carousel-overlay-sales">
                          <h5 className="carousel-title-sales">Sample Title</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

            </div>


          </div>




          {/* Modal for Previous Demo Session and Customer details Form */}
          <Modal
            {...props}
            size="lg"
            show={showSalesFormModel}
            onHide={handleCloseSalesFormModel}
            fullscreen={true}
          >
            <Modal.Body style={{ padding: 0 }} className="p-0">


              {!customerDetFormSess && pendingDemo && pendingDemo !== null ? (
                <div className="modal-overlay3454">
                  <div className="confirmation-modal">
                    <div className="modal-header-new">
                      <h4>You have a previous ongoing session with the following details:</h4>
                      <button className="close-modal-btn" onClick={handleCloseSalesFormModel}>
                        &times;
                      </button>
                    </div>
                    <div className="customer-details">
                      <p><strong>Persona:</strong> <span className="customer-name">{pendingDemo?.Title}</span></p>
                      <p><strong>Customer:</strong> <span className="customer-org">{pendingDemo?.["Customer Organisation"]}</span></p>
                    </div>
                    <p>Do you want to continue with this session or start a new one?</p>
                    <div className="d-flex justify-content-center mt-3">
                      <button className='session-btn-continue' variant="primary" onClick={() => continueWithThisSession(pendingDemo?.Title)}>Continue Session</button>

                      <button

                        variant="secondary"
                        className='session-btn-new'
                        onClick={() => setCustomerDetFormSess(true)}
                      >
                        Start New Session
                      </button>
                      {/* <Button variant="secondary" className="ml-2">Start New Session</Button> */}
                    </div>
                  </div>
                </div>
              ) : (

                <div className="survey-container">
                  <div className="row g-0 align-items-center justify-content-center w-100 m-0">
                    <div className="col-12 col-lg-6 col-md-8 col-sm-12 p-0">
                      <div className="survey-box">


                        {/* Type Selection Cards */}
                        {!formType && (
                          <>
                            <h2 className="survey-title">Select Your Demo Type</h2>
                            <div className="d-flex justify-content-between mb-4">
                              <div className="card-tap" onClick={() => setFormType('Customer')}>
                                <div className="card-body text-center">
                                  <h4 className='card-body-sales-text'>Customer</h4>
                                </div>
                              </div>
                              <div className="card-tap" onClick={() => setFormType('Internal')}>
                                <div className="card-body text-center">
                                  <h4 className='card-body-sales-text'>Internal</h4>
                                </div>
                              </div>
                            </div>
                          </>
                        )}

                        {/* Customer Form */}
                        {formType === 'Customer' && (
                          <>
                            <h2 className="survey-title">Customer Details</h2>
                            <Form onSubmit={handleSubmit}>


                              <Row className="mb-1">
                                {/* Customer Name */}
                                <Form.Group as={Col} md="6" controlId="customerName">
                                  <Form.Control
                                    type="text"
                                    placeholder="Customer Name"
                                    value={customerName}
                                    onChange={(e) => setCustomerName(e.target.value)}
                                    required
                                  />
                                </Form.Group>

                                {/* Customer Organization */}
                                <Form.Group as={Col} md="6" controlId="customerOrg">
                                  <Form.Control
                                    type="text"
                                    placeholder="Customer Organization"
                                    value={customerOrg}
                                    onChange={(e) => setCustomerOrg(e.target.value)}
                                    required
                                  />
                                </Form.Group>
                              </Row>


                              <Row className="mb-1">
                                {/* SFDC ID */}
                                <Form.Group as={Col} md="6" controlId="sfdcId">
                                  <Form.Control
                                    type="text"
                                    placeholder="SFDC ID"
                                    value={sfdcId}
                                    onChange={(e) => setSfdcId(e.target.value)}
                                    required
                                  />
                                </Form.Group>

                                {/* Customer Role */}
                                <Form.Group as={Col} md="6" controlId="customerRole">
                                  <Form.Control
                                    type="text"
                                    placeholder="Customer Role"
                                    value={customerRole}
                                    onChange={(e) => setCustomerRole(e.target.value)}
                                    required
                                  />
                                </Form.Group>

                              </Row>

                              {/* Areas of Interest */}
                              <Form.Group className="mb-3" controlId="areaOfInterest">
                                <Form.Label>Area of Interest</Form.Label>
                                <div className="interest-container">
                                  {interests.map((interest, idx) => (
                                    <Button
                                      key={idx}
                                      variant={areaOfInterest.includes(interest) ? 'secondary' : 'outline-dark'}
                                      onClick={() => handleInterestSelection(interest)}
                                      className="m-1"
                                    >
                                      {interest}
                                    </Button>
                                  ))}
                                </div>
                              </Form.Group>


                              {/* Industry Selection */}
                              <Form.Group className="mb-3" controlId="industrySelection">
                                <Form.Label>Pick Industry</Form.Label>
                                <Form.Control
                                  as="select"
                                  value={selectedIndustry}
                                  onChange={(e) => setSelectedIndustry(e.target.value)}
                                  required
                                >
                                  <option value="">Select Industry</option>
                                  <option value="Automotive">Automotive</option>
                                  <option value="Telco">Telco</option>
                                  <option value="Banking">Banking</option>
                                  <option value="Others">Others</option>
                                </Form.Control>
                              </Form.Group>

                              {/* Custom Industry Input - Only show if "Others" is selected */}
                              {selectedIndustry === 'Others' && (
                                <Form.Group className="mb-3" controlId="customIndustry">
                                  <Form.Control
                                    type="text"
                                    placeholder="Specify Industry"
                                    value={customIndustry}
                                    onChange={handleCustomIndustryChange}
                                  />
                                  {suggestions.length > 0 && (
                                    <ul className="suggestion-list mb-3">
                                      {suggestions.map((suggestion, idx) => (
                                        <li key={idx} onClick={() => handleSuggestionClick(suggestion)}>
                                          {suggestion}
                                        </li>
                                      ))}
                                    </ul>
                                  )}
                                </Form.Group>
                              )}




                              <Form.Group className="mb-3 sales-acknowledgement" controlId="acknowledgement">
                                <Form.Check
                                  type="checkbox"
                                  label="I acknowledge that meeting notes must be submitted to complete this demo."
                                  required
                                />
                              </Form.Group>


                              {/* Submit Button */}
                              <Button
                                variant="primary"
                                type="submit"
                                className="w-100 custom-button"
                              >
                                Submit Details
                              </Button>

                            </Form>
                          </>
                        )}

                        {/* Internal Form */}
                        {formType === 'Internal' && (
                          <>
                            <h2 className="survey-title">Demo Details</h2>
                            <Form onSubmit={handleSubmit}>
                              <Form.Group className="mb-3" controlId="internalOption">
                                <Form.Label>Choose an Option</Form.Label>
                                <div className="internal-options">
                                  <Button
                                    variant={internalOption === 'Meeting Prep' ? 'secondary' : 'outline-dark'}
                                    onClick={() => setInternalOption('Meeting Prep')}
                                    className="m-1"
                                  >
                                    Meeting Prep
                                  </Button>
                                  <Button
                                    variant={internalOption === 'Demo Practice' ? 'secondary' : 'outline-dark'}
                                    onClick={() => setInternalOption('Demo Practice')}
                                    className="m-1"
                                  >
                                    Demo Practice
                                  </Button>
                                </div>
                              </Form.Group>

                              {/* Submit Button */}
                              <Button
                                variant="primary"
                                type="submit"
                                className="w-100 custom-button"
                              >
                                Submit
                              </Button>
                            </Form>
                          </>
                        )}

                        <center><p className='cancel-btn-sale' onClick={handleCloseSalesFormModel}>Cancel</p></center>
                      </div>
                    </div>

                    {/* Image section */}
                    <div className="col-lg-6 d-none d-lg-block survey-image-container p-0">
                      <img
                        src="https://res.cloudinary.com/dueblmbcc/image/upload/v1727810941/Navatic/sss_ppgq59.jpg"
                        alt="Survey Visual"
                        className="survey-image w-100"
                      />
                    </div>
                  </div>
                </div>

              )}




            </Modal.Body>
          </Modal>



          <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            // onHide={handleCloseWhatsNew}
            style={{ backgroundColor: 'rgba(0, 0, 0, 0.4)' }}
            show={showWhatsNew}
            fullscreen={false}
          >
            <Modal.Body className='modalght'>
              <div className="container">
                <div className='modal-div'>
                  <h6 className='what-new-tile'>What's New</h6>
                  <center><hr className='modal-horizontal-line'></hr></center>
                  {newContent.length > 3 ? (
                    <Slider {...settings2}>
                      {newContent.map((item) => (
                        <>
                        <div style={{ padding: "0 5px" }}>
                        <div className='whats-new-card-carsolse' style={{ backgroundImage: `linear-gradient(to bottom, transparent, #000), url(${normalizeMediaUrl(item.thumbnail, 'background')})`  }}>
                          <div className='card-matter'>
                            <div className='card-matter-fixed-height'>
                              <p className='card-matter-date'>{formatDate(item.releaseDate)}</p>
                              <h5 className='card-matter-feature-title'>{item.title}</h5>
                            </div>
                            <p className='card-matter-details'>{item.shortDescription}</p>
                            <Link style={{ textDecoration: 'none', color: 'black' }} to={`${PATH.WHAT_NEW_PATH}${item._id}`}>
                              <p className='card-matter-learnmore'>Learn More {`>>>`}</p>
                            </Link>
                          </div>
                        </div>
                        </div>
                        </>
                      ))}
                    </Slider>
                  ) : (
                    <div className="row" id='row-modal'>
                      {newContent.map((item, index) => (
                        <div className="col-12 col-sm-6 col-md-4" key={index}>
                          <div className='whats-new-card' style={{ backgroundImage: `linear-gradient(to bottom, transparent, #000), url(${normalizeMediaUrl(item.thumbnail, 'background')})` }}>
                            <div className='card-matter'>
                              <p className='card-matter-date'>{formatDate(item.releaseDate)}</p>
                              <div className='card-matter-fixed-height'>
                                <h5 className='card-matter-feature-title'>{item.title}</h5>
                                <p className='card-matter-details'>{item.shortDescription}</p>
                              </div>
                              <Link style={{ textDecoration: 'none', color: 'black' }} to={`${PATH.WHAT_NEW_PATH}${item._id}`}>
                                <p className='card-matter-learnmore'>Learn More {`>>>`}</p>
                              </Link>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <center><p onClick={handleCloseWhatsNew} className='pay-box-pa'>Cancel</p></center>
              </div>
            </Modal.Body>
          </Modal>


        </>
      ) : (
        <>
          <Navbar activeTab={"Homepage"} />
          {/* Solution Engineer Section */}
          <div className='background-color-i'>




            <div class="hero">
              <div class="content-new">
                <div className='container'>
                  <div class="container-home">
                    <div class="row">
                      <div class="col-8">
                        {renderHeroContent()}
                        <p class='v2-hero-tag'>Empowering Sales through Content, Demos & Certifications
                          
                        </p>
                        {/* <Link to='/dash/catalogue'>
              <button className='view-all-narra-button'>View All Narratives</button>
            </Link> */}

                        {enableSearch && (
                          <div class="search-form">
                            <input
                              type="text"
                              placeholder="Search..."
                              value={searchQuery}
                              onKeyDown={handleKeyDown}
                              onChange={handleSearchInputChange} />
                            <button type="submit"
                              onClick={handleSearchSubmit}
                            >
                              <i class="fa-solid fa-arrow-right"></i>
                            </button>
                          </div>
                        )}

                      </div>
                      <div class="col">
                        {renderHeroImage()}
                      </div>
                    </div>


                    {enableDemoIngestions && (
                    <div className='homepage-card-tag'>
                      <div className='container'>
                        <div class="row justify-content-center" id='row-id'>
                          <div className="col" id='col-width'>
                            <div className="column-header">
                              <h6 className='card-title-hero'>
                                <i class="fa-regular fa-star" id='icon-shift'></i>
                                <span className='card-title-hero-dist'>What's New</span>
                              </h6>
                            </div>
                            <ul className="card-list">

                              {newNarratives.slice(0, 3).map(narrative => (
                                <Link to={`${PATH.DEMO_CATALGUE_DETAILS_PATH}${encryptId(narrative._id)}`} style={{ textDecoration: 'none', color: '#fff' }}>
                                  <li>
                                    <div className='card-section-list-one'>
                                      <div class="dis-flex">
                                        <h1 class="narrative-title">{narrative.title}</h1>
                                        <Link to={`${PATH.DEMO_CATALGUE_DETAILS_PATH}${encryptId(narrative._id)}}`}><div class="arrow" style={{ textDecoration: 'none', color: 'white' }}><i class="fa-solid fa-arrow-right"></i></div></Link>
                                      </div>
                                    </div>
                                  </li>
                                </Link>
                              ))}



                            </ul>
                          </div>

                          <div className="col column-with-border" id='col-width'>
                            <div className="column-header">
                              <h6 className='card-title-hero'>
                                <i class="fa-regular fa-star" id='icon-shift'></i>
                                <span className='card-title-hero-dist'>Top Narratives Regionally</span>
                              </h6>
                            </div>
                            <ul className="card-list">
                              {trendingNarratives.slice(0, 3).map(narrative => (
                                <Link to={`${PATH.DEMO_CATALGUE_DETAILS_PATH}${encryptId(narrative._id)}`} style={{ textDecoration: 'none', color: '#fff' }}>
                                  <li>
                                    <div className='card-section-list-one'>
                                      <div class="dis-flex">
                                        <h1 class="narrative-title">{narrative.title}</h1>
                                        <Link to={`${PATH.DEMO_CATALGUE_DETAILS_PATH}${encryptId(narrative._id)}`}><div class="arrow" style={{ textDecoration: 'none', color: 'white' }}><i class="fa-solid fa-arrow-right"></i></div></Link>
                                      </div>
                                    </div>
                                  </li>
                                </Link>
                              ))}
                            </ul>
                          </div>

                          <div className="col column-with-border" id='col-width'>
                            <div className="column-header">
                              <h6 className='card-title-hero'>
                                <i class="fa-regular fa-star" id='icon-shift'></i>
                                <span className='card-title-hero-dist'>Frequently Run Narratives</span>
                              </h6>
                            </div>
                            <ul className="card-list">
                              {frequentNarratives.slice(0, 3).map(narrative => (
                                <Link to={`${PATH.DEMO_CATALGUE_DETAILS_PATH}${encryptId(narrative._id)}`} style={{ textDecoration: 'none', color: '#fff' }}>
                                  <li>
                                    <div className='card-section-list-one'>
                                      <div class="dis-flex">
                                        <h1 className="narrative-title">{narrative.title}</h1>
                                        <Link to={`${PATH.DEMO_CATALGUE_DETAILS_PATH}${encryptId(narrative._id)}`}><div class="arrow" style={{ textDecoration: 'none', color: 'white' }}><i class="fa-solid fa-arrow-right"></i></div></Link>
                                      </div>
                                    </div>
                                  </li>
                                </Link>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    )}
                  </div>
                </div>
              </div>
            </div>


            <div className='mobile-hero'>
              {renderHeroContent()}
              <p class='v2-hero-tag'>Empowering Sales through Content, Demos & Certifications</p>
              {enableSearch && (
                <div class="search-form">
                  <input
                    type="text"
                    placeholder="Search..."
                    value={searchQuery}
                    onKeyDown={handleKeyDown}
                    onChange={handleSearchInputChange} />
                  <button type="submit"
                    onClick={handleSearchSubmit}
                  >
                    <i class="fa-solid fa-arrow-right"></i>
                  </button>
                </div>
              )}
              {/* <Link to='/dash/catalogue'>
    <button className='view-all-narra-button'>View All Narratives</button>
  </Link> */}

              <br></br>
              <br></br>
              <br></br>


              <div className='card-list-pad-home'>
                <div className="column-header">
                  <h6 className='card-title-hero'>
                    <i class="fa-regular fa-star" id='icon-shift'></i>
                    <span className='card-title-hero-dist'>What's New</span>
                  </h6>
                </div>
                <ul className="card-list">
                  {newNarratives.slice(0, 3).map(narrative => (
                    <Link to={`${PATH.DEMO_CATALGUE_DETAILS_PATH}${encryptId(narrative._id)}`} style={{ textDecoration: 'none', color: '#fff' }}>
                      <li>
                        <div className='card-section-list-one'>
                          <div class="dis-flex">
                            <h1 class="narrative-title">{narrative.title}</h1>
                            <Link to={`${PATH.DEMO_CATALGUE_DETAILS_PATH}${encryptId(narrative._id)}}`}><div class="arrow" style={{ textDecoration: 'none', color: 'white' }}><i class="fa-solid fa-arrow-right"></i></div></Link>
                          </div>
                        </div>
                      </li>
                    </Link>
                  ))}
                </ul>


                {/* ------------ */}
                <div className="column-header">
                  <h6 className='card-title-hero'>
                    <i class="fa-regular fa-star" id='icon-shift'></i>
                    <span className='card-title-hero-dist'>Frequently Run Narratives</span>
                  </h6>
                </div>
                <ul className="card-list">
                  {frequentNarratives.slice(0, 3).map(narrative => (
                    <Link to={`${PATH.DEMO_CATALGUE_DETAILS_PATH}${encryptId(narrative._id)}`} style={{ textDecoration: 'none', color: '#fff' }}>
                      <li>
                        <div className='card-section-list-one'>
                          <div class="dis-flex">
                            <h1 className="narrative-title">{narrative.title}</h1>
                            <div class="arrow" style={{ textDecoration: 'none', color: 'white' }}><i class="fa-solid fa-arrow-right"></i></div>
                          </div>
                        </div>
                      </li>
                    </Link>
                  ))}
                </ul>



                {/* ------------------- */}
                <div className="column-header">
                  <h6 className='card-title-hero'>
                    <i class="fa-regular fa-star" id='icon-shift'></i>
                    <span className='card-title-hero-dist'>Top Narratives Regionally</span>
                  </h6>
                </div>
                <ul className="card-list">
                  {trendingNarratives.slice(0, 3).map(narrative => (
                    <Link to={`${PATH.DEMO_CATALGUE_DETAILS_PATH}${encryptId(narrative._id)}`} style={{ textDecoration: 'none', color: '#fff' }}>
                      <li>
                        <div className='card-section-list-one'>
                          <div class="dis-flex">
                            <h1 class="narrative-title">{narrative.title}</h1>
                            <Link to={`${PATH.DEMO_CATALGUE_DETAILS_PATH}${encryptId(narrative.id)}`}><div class="arrow" style={{ textDecoration: 'none', color: 'white' }}><i class="fa-solid fa-arrow-right"></i></div></Link>
                          </div>
                        </div>
                      </li>
                    </Link>
                  ))}
                </ul>
              </div>

            </div>



            {/* <div className='hero-break'>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
            </div>  */}




            {enableDemoIngestions && (
            <section className='homepage-narrative-section'>
              <div className='container'>
                <h1 className='hot-narra-h1-white'>Try these hot narratives</h1>
                <p className='hot-narra-p-white'>A carefully selected compilation of demos that have garnered widespread popularity</p>
                <div class="row">
                  {hotNarratives.map(narrative => (
                    <div class="col-md-4 mb-3">
                      <div class="card">
                        <div className='card-image-sec' style={{ backgroundImage: `linear-gradient(to bottom, transparent, #052140), url(${normalizeMediaUrl(narrative.thumnail, 'background')})` }}>
                          <h6 className='card-titile-catlague'>{narrative.title}</h6>
                        </div>
                        <div class="contained">
                          <p className='card-p-cata'>
                            {narrative.shortDescription}
                          </p>
                          <div class="card-btn-sec-new">
                            <Link to={`${PATH.DEMO_CATALGUE_DETAILS_PATH}${encryptId(narrative._id)}`}>
                              <button className='card-cat-btn1'>View Details</button>
                            </Link>
                            {narrative.playbook ? (
                              <button className='card-cat-btn2' onClick={() => handlePlaybookClick(narrative.playbook)}>
                                Playbook <i className="fa-solid fa-book"></i>
                              </button>
                            ) : (
                              // <button className='card-cat-btn2' onClick={() =>
                              //   Swal.fire({
                              //     title: `Playbook is not availble for ${narrative?.title}`,
                              //     confirmButtonText: 'Retry',
                              //     customClass: {
                              //       title: 'my-custom-title-of-pop-login',
                              //       confirmButton: 'my-custom-button-of-pop',
                              //     },
                              //   })
                              // }>
                              //   Playbook <i className="fa-solid fa-book"></i>
                              // </button>
                              <></>
                            )}
                          </div>
                        </div>
                        <br></br>
                      </div>
                    </div>
                  ))}
                </div>
                <center>
                  <Link to={`${PATH.DEMO_CATALGUE_PATH}`} style={{ textDecoration: 'none' }} >
                    <p className='see-all-narra'>See All Narratives  <i class="fa-solid fa-arrow-right"></i></p>
                  </Link>
                </center>
              </div>
            </section>
            )}
            <br></br>





            {/* Last Block */}
            <section className='why-dc-dection py-5'>
              <div className='container'>
                <div className='row align-items-center'>
                  <div className='col-lg-6 mb-4 mb-lg-0'>
                    <img src={Why_DC} className='why-dc-image img-fluid' alt='Why Tech Central' />
                  </div>
                  <div className='col-lg-6'>
                    <h1 className="why-dc-head mb-4">Why Tech Central?</h1>
                    <div className="row">
                      <div className="col-md-6 mb-4">
                        <div className="item">
                          <h2 className="why-dc-int-head">Simplification</h2>
                          <div className="line my-2"></div>
                          <p className="paragraph">Easy booking process with demo data loaded at the backend and a one-time tenant enrollment for SEs.</p>
                        </div>
                      </div>
                      <div className="col-md-6 mb-4">
                        <div className="item">
                          <h2 className="why-dc-int-head">Speed</h2>
                          <div className="line my-2"></div>
                          <p className="paragraph">Reduced time to deploy narratives with no delays in data loading; however, we cannot add additional narratives without swapping every ingestion app.</p>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 mb-4">
                        <div className="item">
                          <h2 className="why-dc-int-head">Ease of Communication</h2>
                          <div className="line my-2"></div>
                          <p className="paragraph">SEs are kept informed about the latest narratives, with everything consolidated under a single umbrella, including playbook links and release notes.</p>
                        </div>
                      </div>
                      <div className="col-md-6 mb-4">
                        <div className="item">
                          <h2 className="why-dc-int-head">Scale</h2>
                          <div className="line my-2"></div>
                          <p className="paragraph">Can be scaled to a large number of tenants and extended to partners and vendors in the future.</p>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="item">
                          <h2 className="why-dc-int-head">Analytics</h2>
                          <div className="line my-2"></div>
                          <p className="paragraph">
                            Analyze SE behavior to understand which use cases are most frequently used and to gain insights into geographic data.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            {/* X */}






            {/* Modal for selecting playbooks if there are multiple */}
            <Modal show={isModalOpen} onHide={closeModal} centered>
              <Modal.Body>
                <button className="close-button-black" onClick={() => closeModal()}><span aria-hidden="true">&times;</span></button><br></br>
                <div class="row">
                  {selectedPlaybooks.map((playbook, index) => (
                    <div class="col" key={index}>
                      <div className="bg-primary-playbook" onClick={() => handlePlaybookSelection(playbook)}>
                        {playbook.title}
                      </div>
                    </div>
                  ))}
                </div>
              </Modal.Body>
            </Modal>





            {/* Modal for displaying selected playbook */}
            <Modal
              // {...props}
              size="xl"
              show={isPlaybookModalOpen}
              onHide={closePlaybookModal}
              style={{ backgroundColor: 'rgba(0, 0, 0, 0.4)' }}
              centered>

              <Modal.Body className='content-store-popup'>
                <div className="container">
                  <div className='modal-div-learning'>
                    <div className="row">
                      <div className="col-sm-8 mb-3 mb-sm-0">
                        {selectedPlaybook && (
                          <div className="file-container">
                            <iframe src={normalizeMediaUrl(selectedPlaybook.viewUrl, 'preview')} frameborder="0" width="100%" height="100%" allowfullscreen="true" title="File Preview"></iframe>
                          </div>
                        )}
                      </div>
                      <div className="col-sm-4 mb-3 mb-sm-0">
                        <div className="file-controls-dive">
                          <h1 className='file-tite-des'>{selectedPlaybook && selectedPlaybook.title}</h1>
                          <div class="line"></div>
                          {/* <p className='file-p-des'>Publish Date : {selectedPlaybook && selectedPlaybook.releaseDate}</p> */}
                          <p className='file-p-des'>Password :
                            <span
                              onClick={() => copyToClipboard('Playbook@123')}
                              style={{ cursor: 'pointer', }}
                              className='passowrd'>
                              Copy Password
                            </span>
                          </p>
                          <button className='card-cat-cancel' onClick={closePlaybookModal}>Back to Home</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal.Body>
            </Modal>







            {enableWhatsNew && (isDisclaimerAccepted !== 'false') && (
              <Modal
                {...props}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                // onHide={handleCloseWhatsNew}
                style={{ backgroundColor: 'rgba(0, 0, 0, 0.4)' }}
                show={showWhatsNew && !shouldBlockWhatsNewForMigration}
                fullscreen={false}
              >
                <Modal.Body className='modalght'>
                  <div className="container">
                    <div className='modal-div'>
                      <h6 className='what-new-tile'>What's New</h6>
                      <center><hr className='modal-horizontal-line'></hr></center>
                      {newContent.length > 3 ? (
                        
                        <Slider {...settings2}>
                          {newContent.map((item) => (
                            <>
                            <div style={{ padding: "0 5px" }}>
                            <div className='whats-new-card-carsolse' style={{ backgroundImage: `linear-gradient(to bottom, transparent, #000), url(${normalizeMediaUrl(item.thumbnail, 'background')})`  }}>
                              <div className='card-matter'>
                                                       
                                <div className='card-matter-fixed-height'>
                                  <p className='card-matter-date'>{formatDate(item.releaseDate)}</p>
                                  <h5 className='card-matter-feature-title'>{item.title}</h5>
                                </div>
                                <p className='card-matter-details'>{item.shortDescription}</p>
                                <Link style={{ textDecoration: 'none', color: 'black' }} to={`${PATH.WHAT_NEW_PATH}${item._id}`}>
                                  <p className='card-matter-learnmore'>Learn More {`>>>`}</p>
                                </Link>
                              </div>
                            </div>
                            </div>
                            </>
                          ))}
                        </Slider>
                      ) : (
                        <div className="row" id='row-modal'>
                          {newContent.map((item, index) => (
                            <div className="col-12 col-sm-6 col-md-4" key={index}>
                              <div className='whats-new-card' style={{ backgroundImage: `linear-gradient(to bottom, transparent, #000), url(${normalizeMediaUrl(item.thumbnail, 'background')})` }}>
                                <div className='card-matter'>
                                  <p className='card-matter-date'>{formatDate(item.releaseDate)}</p>
                                  <div className='card-matter-fixed-height'>
                                    <h5 className='card-matter-feature-title'>{item.title}</h5>
                                    <p className='card-matter-details'>{item.shortDescription}</p>
                                  </div>
                                  <Link style={{ textDecoration: 'none', color: 'black' }} to={`${PATH.WHAT_NEW_PATH}${item._id}`}>
                                    <p className='card-matter-learnmore'>Learn More {`>>>`}</p>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    <center><p onClick={handleCloseWhatsNew} className='pay-box-pa'>Cancel</p></center>
                  </div>
                </Modal.Body>
              </Modal>
            )}







            {/* Demo Central Learning Portal Popup */}
            {enableEnablement && (
            <Modal
              {...props}
              size="lg"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              backdrop="static"
              show={showDCModal} fullscreen={false}>
              <Modal.Body className='dc-modal'>
                <div className="d-flex flex-column flex-md-row">
                  <div className="order-2 order-md-1 mr-md-3 mb-3 mb-md-0 d-none d-md-block">
                    <img src={DC_img} alt="Tech Central training" className="img-fluid" style={{ maxHeight: '100%', maxWidth: '100%' }} />
                  </div>
                  <div className="order-1 order-md-2">
                    <div className='dc-modal-content'>
                      <p className='dc-modal-hello-ser'>Hello User!</p>
                      <h1 className='dc-modal-heading'>We invite you to complete the essential <span className='dc-modal-heading-orange'>Demo Central<br></br> training</span></h1>
                      <p className='dc-modal-desc'>We're thrilled to enhance your Demo Central experience! Before you dive into exciting new narratives</p>
                      <Link to={`${PATH.LEARNING_HUB_PATH}`}><button className='dc-modal-visit'>Visit Learning Hub</button></Link>
                      <p className='dc-modal-note'>* To access the Demo Central portal, you must undergo this training.</p>
                    </div>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
            )}







          </div>

        </>
      )}






    </>
  )
}

export default Homepage
